const CLIENT_BREAKPOINTS = {
    XS: 0,
    SM: 576,
    MD: 768,
    LG: 992,
    XL: 1200, 

}

export default CLIENT_BREAKPOINTS
